import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import Vue from 'vue';
import d2Container from './d2-container';
import d2ContainerFrame from './d2-container-frame';
Vue.component('d2-container', d2Container);
Vue.component('d2-container-frame', d2ContainerFrame);

var vueFiles = require.context('./', true, /component\.vue$/);

vueFiles.keys().forEach(function (key) {
  var component = vueFiles(key).default;
  Vue.component(component.name, component);
});

var jsFiles = require.context('./', true, /component\.js$/);

jsFiles.keys().forEach(function (key) {
  var component = jsFiles(key).default;
  Vue.component(component.name, component);
});